import { LocalizedString } from 'app/shared/model/localized-string.model';

export enum PaymentBillSource {
  Student = 'student',
  Member = 'member',
  FarpOdq = 'farpOdq',
  FarpOdqSubscription = 'farpOdqSubscription',
  DisciplinaryBoard = 'disciplinaryBoard',
  LegalEntity = 'legalEntity',
}

export interface BillSearchRequest {
  billNumber: string;
  payerName: string;
  amount: number;
}

export interface BillLine {
  billLineId: string;
  description: LocalizedString;
  amount: number;
  quantity: number;
}

export interface BillSearchResult {
  billId: string;
  billCode: string;
  billDate: Date;
  amount: number;
  payerFirstName: string;
  payerLastName: string;
  payerFullName: string;
  payerId?: string;
  source: PaymentBillSource;
  billLines: BillLine[];
  tpsAmount: number;
  tvqAmount: number;
}

export interface PaymentReceipt {
  orderId: string;
  date: string;
  amount: number;
  monerisCardType: string;
  creditCardNumber: string;
  authorizationNumber: string;
}

export interface PaymentStateModel {
  loading: boolean;
  error: string | null;
  result: BillSearchResult | null;
  paymentReceipt: PaymentReceipt | null;
  paymentError: string | null;
}
